import { gql } from './types/generated/gql';

export const MEDIA_UPDATES = gql(`
  subscription mediaUpdates($mediaIds: [String!]!) {
    mediaUpdates(mediaIds: $mediaIds) {
      pipelines {
        ...BTCPipelineMediaUpdateFields
      }
    }
  }
`);
